module.exports = __webpack_public_path__ + "img/sel_Beijing-.f59dda66.png";